export default __webpack_public_path__ + "static/media/Blooded Gloves of the Golden Horde.13175ec5.jpg";